export default "__VITE_ASSET__BcNpy3LY__"